import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';

import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';



import HomePage from './pages/HomePage';
import BouncingLoader from './components/BouncingLoader';
import AboutUsPage from './pages/AboutUsPage';
import ContactUsPage from './pages/ContactUsPage';
import OurProjectsPage from './pages/OurProjectsPage';
import NailovaPresentation from './pages/NailovaPresentation';  
import NookyPresentation from './pages/NookyPresentation';
import FuncityPresentation from './pages/FuncityPresentation';
import TexasACPresentation from './pages/TexasACPresentation';
import ClinicGrowthPage from "./pages/ClinicGrowthPage";
function AppWrapper() {
  const [loading, setLoading] = useState(false);        // Controls loader visibility
  const [pageVisible, setPageVisible] = useState(false); // Controls page content visibility
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    setPageVisible(false); // Hide content while loading

    // Show loader for 2.8s (2 full cycles)
    const loaderTimeout = setTimeout(() => {
      setLoading(false);
    }, 1500);

    // Show page shortly *after* loader finishes
    const pageTimeout = setTimeout(() => {
      setPageVisible(true);
    }, 1500); // Wait an extra 0.5s after loader

    return () => {
      clearTimeout(loaderTimeout);
      clearTimeout(pageTimeout);
    };
  }, [location.pathname]);

  return (
    <>
      <BouncingLoader show={loading} />
      {pageVisible && (
        <>
          <Header />

          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<HomePage />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route path="/contact-us" element={<ContactUsPage />} />
            <Route path="/start-a-project" element={<ContactUsPage />} />
            <Route path="/our-projects" element={<OurProjectsPage />} />
            <Route path="/nailova" element={<NailovaPresentation />} />
            <Route path="/nooky" element={<NookyPresentation />} />
            <Route path="/funcity" element={<FuncityPresentation />} />
            <Route path="/texasac" element={<TexasACPresentation />} />
            <Route path="/clinic" element={<ClinicGrowthPage />} />

            
          </Routes>
          <Footer />
        </>
      )}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;
